/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

const hideGlobalSpinner = () => {
  try {
    const spinner = document.getElementById('nb-global-spinner');
    if (spinner) {
      spinner.style.display = 'none';
      // Also remove it from DOM to avoid intercepting events
      spinner.parentElement?.removeChild(spinner);
    }
  } catch {}
};

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(() => hideGlobalSpinner())
  .catch(err => {
    console.error(err);
    hideGlobalSpinner();
  });
